// extracted by mini-css-extract-plugin
export default {"header2":"Z5saEysSPqJO4tq8m1E1","skipMargin":"VZhZ5UOKZL8IDC3sdcS4","wide":"EzedKNNN_KwehnTKtUz9","placeHolderShimmer":"NV8kOAnEk1rwv0kG_c9P"};